import React from "react";

const AboutusItem = (props) => {
  return (
    <React.Fragment>
      {props.aboutItemData.map((item, index) => {
        return (
          <div key={index} className="aboutusItem">
            <div className="imageFigure">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="aboutText">
              <p className="title">{item.title}</p>
              <p className="description" dangerouslySetInnerHTML={{ __html: item.detail }}></p>
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default React.memo(AboutusItem);
